<div class="task-dialog-container" style="width: 400px; max-width: 90vw">
  <!-- Fixed header section -->
  <div class="dialog-header">
    <app-patient-info-card
      [patientInfo]="data.patient_info"
      (closeCard)="onClose()"
    ></app-patient-info-card>
  </div>

  <!-- Scrollable content section -->
  <mat-dialog-content class="dialog-content">
    <mat-card-content>
      <app-task-card
        *ngFor="let task of history"
        [task]="task"
        [viewContentI18n]="viewContentI18n"
        [patientInfo]="data.patient_info"
        (editTask)="
          onClickOnElement($event.formFileName, $event.taskData, $event.patientInfo, $event.history)
        "
      ></app-task-card>
    </mat-card-content>
  </mat-dialog-content>
</div>
